import 'Assets/styles/default/pages/focalPoint/FocalPointManagePointsStyles.less';
import React from 'react';
import {
    VertModal,
    VertButton,
    Typography
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';

const RemoveParticipantSuccessModal = ({ isOpen, onClose }) => {

    return (
        <VertModal
            destroyOnClose={true}
            open={isOpen}
            onCancel={() => {
                onClose();
            }}
            className="container-modal-focal-point-manage"
            closable={false}
        >
            <Row justify={'center'}
                gutter={[16, 16]}
            >
                <Col span={24}>
                    <Row justify={'center'}>
                        <Typography.Text className='modal-remove-participant-text'>
                            Distribuição excluída com sucesso
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24} className='modal-remove-participant-container-button'>

                    <VertButton
                        onClick={() => { onClose() }}
                        type="highlight"
                        size="default"
                        className='button-historic-redirect button-focal-point width-100'
                    >
                        Entendi
                    </VertButton>

                </Col>

            </Row >

        </VertModal >
    );
};

export default RemoveParticipantSuccessModal;
